import {
  useTranslate,
  IResourceComponentsProps,
  useShow,
} from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { IMessage } from "interfaces";

const { Title, Text } = Typography;

export const MessageShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { queryResult } = useShow<IMessage>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{t("message.fields.message")}</Title>
      <Text>{record?.message}</Text>

      <Title level={5}>{t("message.fields.link")}</Title>
      <Text>{record?.link}</Text>
    </Show>
  );
};
